import { createFileRoute, notFound, type SearchSchemaInput } from '@tanstack/react-router';
import { canUseMockMode } from '@/lib/mock-mode';
import { AhsAdminPage } from '@/features/ahs-admin/ahs-admin-page';
import { sandboxSearch } from '@/features/ahs-admin/format';

const positive = (value: unknown): number | undefined => {
  const n = typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : NaN;
  return Number.isInteger(n) && n > 0 ? n : undefined;
};

// Dreamwell staff only: anyone else gets the not-found page (the API refuses them too). `teamId` looks at another team
// than the staff member's own; `item` opens one of its items. Read in the component, which is split from the entry.
export const Route = createFileRoute('/_authed/admin/ahs')({
  validateSearch: (search: { teamId?: unknown; item?: unknown } & SearchSchemaInput) => search as { teamId?: unknown; item?: unknown },
  beforeLoad: ({ context: { user } }) => {
    if (!canUseMockMode(user.email)) throw notFound();
  },
  component: AhsAdminRoute,
});

function AhsAdminRoute() {
  const { team } = Route.useRouteContext();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  if (!team) return null;
  const shown = positive(search.teamId) ?? team.id;
  const item = typeof search.item === 'string' && search.item.includes(':') ? search.item : null;
  return (
    <AhsAdminPage
      key={shown}
      teamId={shown}
      ownTeamId={team.id}
      itemKey={item}
      onOpen={(next, nextItem) => void navigate({ search: sandboxSearch(next, nextItem) })}
    />
  );
}
